import { render, staticRenderFns } from "./CategoryCreateDialog.vue?vue&type=template&id=825cb7ac&scoped=true"
import script from "./CategoryCreateDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825cb7ac",
  null
  
)

export default component.exports